module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "step1-form step2_bl",
    style: ({
      minHeight: (_vm.screenHeight - 85) + 'px'
    })
  }, [(this.$route.query.yanse == 1) ? _c('div', {
    staticClass: "step-form__step-num2"
  }, [_vm._v("1/5")]) : _vm._e(), _vm._v(" "), (this.$route.query.yanse == 2) ? _c('div', {
    staticClass: "step-form__step-num"
  }, [_vm._v("1/5")]) : _vm._e(), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "step-form__main"
  }, [_c('h1', {
    staticClass: "step-form__title"
  }, [_vm._v(_vm._s(this.$route.query.productName) + "-填写融资基本信息")]), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 0
    }
  }, [(!this.$route.query.productName.includes('交')) ? _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$route.query.yanse == 1),
      expression: "this.$route.query.yanse == 1"
    }],
    staticStyle: {
      "margin-left": "10px",
      "margin-top": "90px"
    },
    on: {
      "click": _vm.addTable
    }
  }, [_vm._v("+")]) : _vm._e(), _vm._v(" "), (!this.$route.query.productName.includes('交')) ? _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$route.query.yanse == 1),
      expression: "this.$route.query.yanse == 1"
    }],
    staticStyle: {
      "margin-left": "20px",
      "margin-top": "110px"
    },
    on: {
      "click": _vm.importData
    }
  }, [_vm._v("导入")]) : _vm._e(), _vm._v(" "), (this.$route.query.productName.includes('交')) ? _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$route.query.yanse == 1),
      expression: "this.$route.query.yanse == 1"
    }],
    staticStyle: {
      "margin-left": "10px",
      "margin-top": "190px"
    },
    on: {
      "click": _vm.addTable
    }
  }, [_vm._v("+")]) : _vm._e(), _vm._v(" "), (this.$route.query.productName.includes('交')) ? _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$route.query.yanse == 1),
      expression: "this.$route.query.yanse == 1"
    }],
    staticStyle: {
      "margin-left": "20px",
      "margin-top": "210px"
    },
    on: {
      "click": _vm.importData
    }
  }, [_vm._v("导入")]) : _vm._e(), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 16
    }
  }, [_c('el-form', {
    ref: "step2Form",
    staticClass: "step-form__form",
    attrs: {
      "label-width": '50%',
      "model": _vm.step2Form,
      "rules": _vm.rules
    }
  }, [_c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$route.query.yanse == 1),
      expression: "this.$route.query.yanse == 1"
    }],
    attrs: {
      "label": "买方",
      "prop": "buyerId"
    }
  }, [_c('el-select', {
    staticClass: "buyerName",
    attrs: {
      "placeholder": "请选择买方"
    },
    model: {
      value: (_vm.step2Form.buyerId),
      callback: function($$v) {
        _vm.$set(_vm.step2Form, "buyerId", $$v)
      },
      expression: "step2Form.buyerId"
    }
  }, _vm._l((_vm.partnerList), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.buyerName,
        "value": item.buyerId
      }
    })
  }), 1)], 1), _vm._v(" "), (this.$route.query.productName.includes('交')) ? _c('el-form-item', {
    attrs: {
      "label": "贸易基础交易合同起止日"
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "47%"
    },
    attrs: {
      "type": "date",
      "value-format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.step2Form.businessContractStartDate),
      callback: function($$v) {
        _vm.$set(_vm.step2Form, "businessContractStartDate", $$v)
      },
      expression: "step2Form.businessContractStartDate"
    }
  }), _vm._v("至\n                "), _c('el-date-picker', {
    staticStyle: {
      "width": "47%"
    },
    attrs: {
      "type": "date",
      "value-format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.step2Form.businessContractEndDate),
      callback: function($$v) {
        _vm.$set(_vm.step2Form, "businessContractEndDate", $$v)
      },
      expression: "step2Form.businessContractEndDate"
    }
  })], 1) : _vm._e(), _vm._v(" "), (this.$route.query.productName.includes('交')) ? _c('el-form-item', {
    attrs: {
      "label": "交易标的品种"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "tel",
      "placeholder": "请输入交易标的品种"
    },
    model: {
      value: (_vm.step2Form.scmBusinessType),
      callback: function($$v) {
        _vm.$set(_vm.step2Form, "scmBusinessType", $$v)
      },
      expression: "step2Form.scmBusinessType"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', [(this.$route.query.yanse == 1) ? _c('el-table', {
    attrs: {
      "data": _vm.tableDatas,
      "border": "",
      "show-summary": "",
      "sum-text": "发票总金额",
      "summary-method": _vm.getSummaries
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "发票编码",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          attrs: {
            "placeholder": "先输入发票号后输入金额",
            "input": _vm.setAmountValue(scope.row.code, scope.$index)
          },
          model: {
            value: (scope.row.code),
            callback: function($$v) {
              _vm.$set(scope.row, "code", $$v)
            },
            expression: "scope.row.code"
          }
        })]
      }
    }], null, false, 902129682)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "发票金额（元）",
      "prop": "amount",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          attrs: {
            "type": "number",
            "text-align": "center",
            "disabled": scope.row.code == ''
          },
          model: {
            value: (scope.row.amount),
            callback: function($$v) {
              _vm.$set(scope.row, "amount", $$v)
            },
            expression: "scope.row.amount"
          }
        })]
      }
    }], null, false, 3259632031)
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "经办人",
      "prop": "agent"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "tel",
      "placeholder": "请输入经办人名字"
    },
    model: {
      value: (_vm.step2Form.agent),
      callback: function($$v) {
        _vm.$set(_vm.step2Form, "agent", $$v)
      },
      expression: "step2Form.agent"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "经办人身份证",
      "prop": "agentIdNo"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "tel",
      "placeholder": "请输入经办人身份证号码",
      "maxlength": 18
    },
    model: {
      value: (_vm.step2Form.agentIdNo),
      callback: function($$v) {
        _vm.$set(_vm.step2Form, "agentIdNo", $$v)
      },
      expression: "step2Form.agentIdNo"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "经办人电话",
      "prop": "agentContact"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "tel",
      "placeholder": "请输入经办人电话",
      "maxlength": 11
    },
    model: {
      value: (_vm.step2Form.agentContact),
      callback: function($$v) {
        _vm.$set(_vm.step2Form, "agentContact", $$v)
      },
      expression: "step2Form.agentContact"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "其他说明",
      "prop": "ortherRemark"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "placeholder": "",
      "rows": 5
    },
    model: {
      value: (_vm.step2Form.ortherRemark),
      callback: function($$v) {
        _vm.$set(_vm.step2Form, "ortherRemark", $$v)
      },
      expression: "step2Form.ortherRemark"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "step-form__btn-container"
  }, [(this.$route.query.yanse == 1) ? _c('button', {
    staticClass: "step-form__btn-next2",
    on: {
      "click": function($event) {
        return _vm.submitForm('step2Form')
      }
    }
  }, [_vm._v("下一步")]) : _vm._e(), _vm._v(" "), (this.$route.query.yanse == 2) ? _c('button', {
    staticClass: "step-form__btn-next",
    on: {
      "click": function($event) {
        return _vm.submitForm('step2Form')
      }
    }
  }, [_vm._v("下一步")]) : _vm._e()])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.dialogTicketInfo,
      "show-close": true,
      "top": "70px"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogTicketInfo = $event
      }
    }
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.contractText)
    }
  })]), _vm._v(" "), _c('el-dialog', {
    staticClass: "fail-modal",
    attrs: {
      "top": "23%",
      "visible": _vm.gylFailModal.show,
      "before-close": _vm.beforeCloseGylFileModal,
      "close-on-click-modal": false
    }
  }, [_c('div', {
    staticClass: "fail-modal__text"
  }, [_vm._v(_vm._s(_vm.gylFailModal.content))])]), _vm._v(" "), _c('el-dialog', {
    staticClass: "dialog-import",
    attrs: {
      "title": "导入发票号",
      "visible": _vm.dialogImportVisibleExcel,
      "modal-append-to-body": false,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogImportVisibleExcel = $event
      }
    }
  }, [_c('div', {
    class: {
      'import-content': _vm.importFlag === 1, 'hide-dialog': _vm.importFlag !== 1
    }
  }, [_c('el-upload', {
    staticClass: "upload-demo",
    attrs: {
      "action": _vm.importUrl,
      "name": _vm.name,
      "data": _vm.excelData,
      "headers": _vm.importHeaders,
      "on-preview": _vm.handlePreview,
      "on-remove": _vm.handleRemove,
      "before-upload": _vm.beforeUploadImportExcel,
      "on-error": _vm.uploadFailImport,
      "on-success": _vm.uploadSuccessImport,
      "file-list": _vm.fileList,
      "with-credentials": _vm.withCredentials
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary",
      "disabled": _vm.processing
    }
  }, [_vm._v(_vm._s(_vm.uploadTip))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary",
      "round": ""
    },
    on: {
      "click": _vm.downTemplate
    }
  }, [_vm._v("下载模板")]), _vm._v(" "), _c('div', {
    staticClass: "el-upload__tip",
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_vm._v("只能上传excel文件")])], 1)], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fb39ca9c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/applyLoan/Step2.vue
// module id = 1104
// module chunks = 1